import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';

import dateSwitch from '@/components/dateSwitch/index.vue';
import search from '@/components/search/index.vue';
import preloader from '@/components/preloader/index.vue';
import taskJobView from '@/components/helpers/taskJobView/index.vue';
import pagination from '@/components/paginationSimple/index.vue';
import filters from '@/components/filters/index.vue';
import empty from '@/components/emptyContainer/index.vue';

import Api from '@/utils/api';

import { JOB_STATUS } from '@/utils/const';

export default {
  name: 'Tasks',
  components: {
    dateSwitch,
    Multiselect,
    preloader,
    DatePicker,
    taskJobView,
    pagination,
    search,
    filters,
    empty,
  },
  data () {
    return {
      tasks: [],
      responseData: [],
      jobStatus: JOB_STATUS,

      dateFilterSwitch: [],

      filterParams: {
        name: 'tasks?',
        url: '',
      },

      pagination: {
        page: 1,
        ppage: 6,
      },

      load: true,
      search: false,
    };
  },
  watch: {
    pagination: {
      deep: true,
      handler () {
        this.getData();
      },
    },
  },
  computed: {
    countPage () {
      return this.taskTotalCount < this.pagination.ppage ? this.taskTotalCount : this.pagination.ppage;
    },
  },
  created () {
    this.$store.dispatch('SHOW_PRELOADER', false);
  },
  mounted () {
    setTimeout(() => {
      this.scrollToTop();
    }, 1000);
  },
  methods: {
    scrollToTop() {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    },
    dateSwitchJob (item) {
      this.dateFilterSwitch = item.value;
    },

    holderSearch (searchString) {
      this.pagination.page = 1;
      this.load = true;
      this.search = searchString;
      this.getSearchTasks();
    },

    setFilter (params) {
      this.pagination.page = 1;
      this.load = true;
      this.filterParams = params;
      this.getFiltersTasks();
    },

    /**
         * Method for reset search text
         */
    resetSearch () {
      this.search = '';
      this.getSearchTasks();
    },

    getSearchTasks () {
      Api.search('tasks', this.search, { page: this.pagination.page, perPage: this.pagination.ppage })
        .then((data) => {
          this.holderResponse(data);
        });
    },

    getFiltersTasks () {
      this.load = true;

      Api.filters
        .sendFilters(this.filterParams, { page: this.pagination.page, perPage: this.pagination.ppage })
        .then((data) => {
          this.holderResponse(data);
        });
    },

    holderResponse (data) {
      if (data.data.Status) {
        this.tasks = data.data.Data;
        this.responseData = data.data;
      } else {
        this.tasks = [];
        this.responseData = [];
      }
      this.load = false;
      this.scrollToTop();
    },
    getData () {
      if (this.search) {
        this.getSearchTasks(this.search);
      } else {
        this.getFiltersTasks();
      }
    },
  },
};
